<template>
  <div :class="[
      {'position-label': position.filled},
      positionLabelStyle,
      {'position-label--pis-set': PIsSet}
    ]">
    <TacticsBoardPositionPISetIndicator 
      v-if="PIsSet"
      :class="positionLabelStyle" />

    <div class="selected-role-name">
      <div class="selected-role-name__container">
        <span>{{ selectedRole.shortName }}</span>
        <span class="divider">-</span>
        <DutyLabel
          :duty="selectedRole.duty"
          :shortDisplayStyle="true" />
        <font-awesome-icon 
          icon="fa-solid fa-caret-down"
          class="dropdown-caret" />
      </div>
    </div>

    <TacticsBoardPositionRoleSelect
      :position="position"
      :selectedRole="selectedRole"
      @change:role="$emit('change:role', $event)" />
  </div>
</template>

<script>
import TacticsBoardPositionPISetIndicator from "@/components/TacticsBoardPositionPISetIndicator";
import TacticsBoardPositionRoleSelect from "@/components/TacticsBoardPositionRoleSelect";
import DutyLabel from "@/components/DutyLabel";

export default {
  props: [
    "position",
    "selectedRole"
  ],

  components: {
    TacticsBoardPositionPISetIndicator,
    TacticsBoardPositionRoleSelect,
    DutyLabel
  },

  computed: {
    positionLabelStyle() {
      const style = {};
      style[`position-label--${this.position.stratum.name.toLowerCase()}-row`] = this.position.filled;
      return style;
    },

    PIsSet() {
      return this.position.customInstructions.listInstructions().length;
    }
  }
}
</script>

<style scoped>
  .selected-role-name {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: white;
    font-weight: 500;
    font-size: small;
    pointer-events: none;
    padding: 0 12px;
  }

  .divider {
    margin: 0 4px;
  }

  .dropdown-caret {
    margin-left: auto;
  }

  .selected-role-name__container {
    display: flex;
    justify-content: center;
  }

  .position-label {
    border-radius: 6px;
    position: relative;
    padding: 4px;
    height: 24px;
  }
  .position-label--pis-set {
    border-top-left-radius: 0;
  }
  .position-label--gk-row {
    background: #615C50;
  }
  .position-label--d-row {
    background: #3D75A4;
  }
  .position-label--dm-row {
    background: #687581;
  }
  .position-label--m-row {
    background: #44515C;
  }
  .position-label--am-row {
    background: #252E34;
  }
  .position-label--st-row {
    background: #655984;
  }
</style>
